/**
 * Константы для компонента таблицы
 */

/** Фиксированные столбцы таблицы */
export const TABLE_FIXED_COLUMS = ['select'];
